/* eslint-disable jsx-a11y/anchor-is-valid */
import { range } from 'lodash'
import * as React from 'react'

// Assets
import GAExample from '../assets/GA_example.png'

// Components
import { Modal } from 'components/modal'

// Modules
import { DI } from 'modules'

const PaymentInstructions = ({ common }) => {
  // Setup
  const { strings } = common
  const prefix = 'page.payment.licence.requirement.instructions'

  // State
  const [isOpened, setOpenState] = React.useState(false)

  // Handlers
  const handleToggle = React.useCallback(
    () => setOpenState(!isOpened),
    [isOpened]
  )

  return (
    <p className="_padded">
      <a href="#" onClick={handleToggle}>
        {strings[prefix]}
      </a>

      {isOpened && (
        <Modal onClose={handleToggle}>
          <div className="popup-text">
            <div className="text">
              <h4>{strings[`${prefix}.title`]}</h4>
              <p>{strings[`${prefix}.text`]}</p>

              <ul>
                {range(1, 6).map(index => (
                  <li
                    key={index}
                    dangerouslySetInnerHTML={{
                      __html: strings[`${prefix}.items_${index}`],
                    }}
                  />
                ))}
              </ul>

              <img alt="GA Example" src={GAExample} />
            </div>
          </div>
        </Modal>
      )}
    </p>
  )
}

export default DI(['common'])(PaymentInstructions)
